module.exports = __webpack_public_path__ + "static/media/settings-blue.01bdf8ec.svg";